



























































import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-text-to-speech',
  components: {}
}

@Component(config)
export default class IconTextToSpeech extends Vue {}
